import { render, staticRenderFns } from "./ContentClassLegend.vue?vue&type=template&id=624cdb68&scoped=true&"
import script from "./ContentClassLegend.vue?vue&type=script&lang=js&"
export * from "./ContentClassLegend.vue?vue&type=script&lang=js&"
import style0 from "./ContentClassLegend.vue?vue&type=style&index=0&id=624cdb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624cdb68",
  null
  
)

export default component.exports